{
   "splash_button": {
      "en"  :  "Launch", 
      "fr"  :  "Lancer",
      "es"  :  "Iniciar"
   },
   "splash_copyright p": {
      "en"  :  "Once you tap Launch, we'll use cookies to<br>enable operation of the site, and to<br>measure usage and engagement.<p>",
      "fr"  :  "Après avoir cliqué sur Lancer, nous utiliserons<br>des cookies pour permettre l'exploitation<br>du site et pour mesurer l'utilisation et l'engagement.",
      "es"  :  "Al dar click en INICIAR, utilizaremos<br>cookies para habilitar la operación del<br>sitio y para medir el uso y la participación."  
   },
   "splash_privacyPolicy a": {
      "en"  :  "Privacy Policy", 
      "fr"  :  "Politique de confidentialité",
      "es"  :  "Política de Privacidad"
   },
   "permissions_button": {
      "en"  :  "Continue",
      "fr"  :  "Continuer",
      "es"  :  "Continuar"
   },
   "permissions main h1": {
      "en"  :  "Camera access is required for this<br>Augmented Reality experience", 
      "fr"  :  "L'accès à la caméra est nécessaire<br>pour l'expérience de réalité augmentée.",
      "es"  :  "El acceso a la cámara es necesario<br>para la experiencia de Realidad Aumentada "
   },
   "permissions main span" : {
      "en"  :  "Please <strong>ALLOW</strong> permissions<br>for the experience", 
      "fr"  :  "Veuillez <strong>Accepter</strong>  pour autoriser l'expérience",
      "es"  :  "Por favor autorice el permiso para la experiencia"
   },
   "permissions_cancel": {
      "en"  :  "Cancel", 
      "fr"  :  "Annuler",
      "es"  :  "Cancelar"
   },
   "permissions_allow": {
      "en"  :  "ALLOW", 
      "fr"  :  "ACCEPTER",
      "es"  :  "PERMITIR"
   },
   "prompt_heading": {
      "en"  :  "Ensure the whole pack fits within the camera frame", 
      "fr"  :  "S'assurer que l'ensemble du pack tient dans le cadre de l'appareil photo",
      "es"  :  "Asegura que todo el empaque quede dentro del marco de la cámara"
   },
   "prompt_button": {
      "en"  :  "SKIP", 
      "fr"  :  "PASSER<br>L'ÉTAPE",
      "es"  :  "SALTAR"
   },
   "prompt_subheading strong": {
      "en"  :  "POINT PHONE", 
      "fr"  :  "",
      "es"  :  "DIRIJA EL TELÉFONO"
   },
   "prompt_subheading p": {
      "en"  :  "at the", 
      "fr"  :  "Viser le pack de",
      "es"  :  "hacia el empaque "
   },
   "prompt_subheading p2": {
      "en"  :  "pack", 
      "fr"  :  "",
      "es"  :  ""
   },
   "prompt footer strong": {
      "en"  :  "Don't", 
      "fr"  :  "",
      "es"  :  "No tengo"
   },
   "prompt footer p": {
      "en"  :  "have a", 
      "fr"  :  "Ce n'est pas un pack",
      "es"  :  "un empaque"
   },
   "prompt footer p2": {
      "en"  :  "pack ...", 
      "fr"  :  "...",
      "es"  :  "..."
   },
   "intro_1" : {
      "en"  :  "No Bleed<br>Vibrant Colors", 
      "fr"  :  "Ne traverse pas le<br>papier, couleurs vives",
      "es"  :  "NO TRASPASA EL PAPEL,<br>COLORES VIBRANTES"
   },
   "intro_2" : {
      "en"  :  "Pops on Light &<br>Dark Surfaces", 
      "fr"  :  "Idéal sur des surfaces<br>claires et sombres",
      "es"  :  "IDEAL PARA SUPERFICIES<br>CLARAS Y OSCURAS"
   },
   "lookAround_prompt strong" : {
      "en"  :  "LOOK AROUND", 
      "fr"  :  "REGARDEZ AUTOUR",
      "es"  :  "MIRA ALREDEDOR" 
   },
   "lookAround_prompt p" : {
      "en"  :  "the scene", 
      "fr"  :  "de vous",
      "es"  :  "de la escena"
   },
   "draw_deleteMenuTitleText p": {
      "en"  :  "Are you sure you want to<br>delete everything?", 
      "fr"  :  "Are you sure you want to<br>delete everything?", 
      "es"  :  "Are you sure you want to<br>delete everything?"
   },
   "draw_deleteMenuTitleText strong": {
      "en"  :  "This cannot be undone", 
      "fr"  :  "This cannot be undone",
      "es"  :  "This cannot be undone"
   },
   "draw_deleteMenuYesButton": {
      "en"  :  "YES", 
      "fr"  :  "Oui",
      "es"  :  "SÍ"
   },
   "draw_deleteMenuNoButton": {
      "en"  :  "NO", 
      "fr"  :  "Non",
      "es"  :  "NO"
   },
   "download_saveButton": {
      "en"  :  "Save",
      "fr"  :  "Sauvegarder",
      "es"  :  "Guardar"
   },
   "download_shareButton": {
      "en"  :  "Share",
      "fr"  :  "Partager",
      "es"  :  "Compartir"
   },
   "download_saveShareButton": {
      "en"  :  "Save or Share",
      "fr"  :  "Sauvegarder / Partager",
      "es"  :  "Guardar o Compartir"
   },
   "penSelection_continueButton": {
      "en"  :  "Continue",
      "fr"  :  "Continuer",
      "es"  :  "Continuar"
   },
   "tutorial header p": {
      "en"  :  "Tap 'x' button to close",
      "fr"  :  "Appuyez sur ‘x’ pour fermer",
      "es"  :  "Toca el botón “x” para cerrar"
   },
   "tutorial_text1Top p": {
      "en"  :  "Join the fun by drawing<br>with us, or start from a<br>blank canvas by tapping",
      "fr"  :  "Amusez-vous en dessinant avec<br>nous, ou créez à partir d’une<br>toile blanche en cliquant ici",
      "es"  :  "Únete a la diversión dibujando<br>con nosotros, o comienza un<br>lienzo en blanco tocando aquí"
   },
   "tutorial_text2 p": {
      "en"  :  "Use your finger to try out<br>the markers and make the<br>world your canvas",
      "fr"  :  "Essayez les marqueurs à l’aide<br>de votre doigt et faites du<br>monde votre toile.",
      "es"  :  "Usa tu dedo para probar<br>los marcadores y hacer<br>del mundo tu lienzo"
   },
   "tutorial_text3 p": {
      "en"  :  "You can snap a photo of your<br>creations, or record a video by<br>holding the camera button",
      "fr"  :  "Vous pouvez prendre une photo de<br>votre creation ou enregistrer une<br>video en maintenant appuyé le<br>bouton de l’appareil photo",
      "es"  :  "Puedes tomar una foto de tus<br>creaciones o grabar un video<br>manteniendo presionado el<br>botón de la cámara"
   },
   "draw_deleteMenuTitleText span p": {
      "en"  :  "Are you sure you want to<br>delete everything?",
      "fr"  :  "Etes-vous certain(e)<br>de vouloir tout effacer ?",
      "es"  :  "¿Estás de acuerdo en<br>querer eliminar todo?"
   },
   "draw_deleteMenuTitleText span strong": {
      "en"  :  "This cannot be undone",
      "fr"  :  "Vous ne pourrez plus<br>revenir en arrière.",
      "es"  :  "Esto no se podrá deshacer."
   },
   "gyroPrompt header": {
      "en"  :  "Look straight<strong>AHEAD</strong>",
      "fr"  :  "Regardez droit devant vous.",
      "es"  :  "Mira hacia adelante"
   }

}